<template>
  <div class="preview-manager">
    <page-title
      :title="this.$router.currentRoute.params.type.capitalize() + ' Preview'"
    ></page-title>
    <v-layout
      v-if="controlVisible"
      class="preview-manager-tools"
      align-center
      justify-center
    >
      <v-btn style="border: 2px solid #fff" small fab dark color="accent" @click="desktop">
        <v-icon style="padding-top: 17px" dark>desktop_mac</v-icon>
      </v-btn>
      <v-btn style="border: 2px solid #fff" small fab dark color="accent" @click="mobile">
        <v-icon style="padding-top: 17px" dark>stay_current_portrait</v-icon>
      </v-btn>
      <v-btn style="border: 2px solid grey" class="close" @click="controlVisible = false" dark icon>
        <v-icon >close</v-icon>
      </v-btn>
    </v-layout>
    <div :style="iframeStyle" class="preview-area">
      <!--<img class="preview-mock" :src="require('./assets/apple-iphone5-black-portrait.png')" />-->
      <iframe class="preview-iframe" :src="iframeLink"></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PreviewManager',
  mounted() {
    document.getElementsByTagName('html')[0].style.overflowY = 'hidden'
    document.getElementsByTagName('body')[0].style.overflowY = 'hidden'
  },
  data() {
    return {
      view: 'desktop',
      controlVisible: true
    }
  },
  computed: {
    iframeStyle() {
      const css = {}
      if (this.view === 'desktop') {
        css.width = '100%'
        css.height = '100vh'
        if (this.controlVisible) {
          css.marginTop = '60px'
          css.height = 'calc(100vh - 60px)'
        } else {
          css.height = '100vh'
          css.marginTop = '0px'
        }
      } else {
        css.width = '370px'
        css.height = '600px'
        if (this.controlVisible) {
          css.marginTop = '100px'
        } else {
          css.marginTop = '60px'
        }
      }
      return css
    },
    iframeLink: function() {
      if (this.$router.currentRoute.params.type === 'feedback') {
        return `/feedback-preview?campaign_id=${this.$router.currentRoute.params.campaignId}&metric_type=${this.$router.currentRoute.params.metricType}`
      }
      return `/proof-preview?campaign_id=${this.$router.currentRoute.params.campaignId}#pricing`
    }
  },
  methods: {
    mobile() {
      this.view = 'mobile'
    },
    desktop() {
      this.view = 'desktop'
    }
  }
}
</script>

<style scoped lang="stylus">
.preview-manager {
    text-align: center;
    .preview-manager-tools {
        height: 60px;
        background-color: #000;
        width: 100%;
        position: fixed;
        top: 0;
        left: 0;
  }
    .close {
        position: absolute;
        right: 15px;
        margin-top: 0px;
    }
    .preview-mock {
        position: absolute;
    }
    .preview-area{
        margin: auto;
        transition: all .5s;
    }
    .preview-iframe {
        width: 100%;
        height: 100%;
        border: 0;
        margin: auto;
        transition: all 1s;
    }
  }
</style>
